<template>
  <ModuleInfoModal
      :is-open="isModuleInfoModalOpen"
      :module="selectedModule"
      :pinableSems=null
      :currentSemester="currentSemester"
      :search=true
      :modal-name="modalName"
      :baseModuleModal = "openedInBaseModuleModal"
      :assignedSemester="currentSemester"
      :unavailableModules="unavailableModules"
      :unavailableReason="'not offered'"
      @close="closeModuleInfoModal"
      @select-module="selectModule"
      @specify-module="handleSpecifyModule"
    />
  <base-modal
      :is-open="isOpen"
      :icon-modal="iconModal"
      :modal-title="modalTitle || defaultTitle"
      :closing-offered="false"
      :modal-name="modalName"
      :modal-subtitle="modalSubtitle"
      :length="600"
      @beforeClose="$emit('close')"
      :class="modalClass"
  >
    <template #header-controls>
      <!--<div class="header-action-btn" @click="triggerPdfDownload" title="Download PDF">
        <span class="material-symbols-outlined">picture_as_pdf</span>
      </div>-->
      <div v-if="!withoutPreview" class="header-action-btn" @click="openEdit" title="Edit Custom Sessions">
        <span class="material-symbols-outlined">edit_calendar</span>
      </div>
      <div class="header-action-btn" @click="showSettings = !showSettings" title="Semester settings">
        <span class="material-symbols-outlined" :class="{ 'settings-active': showSettings, 'settings-modified': localSemesterPreferences && localSemesterPreferences.default === false }">settings</span>
      </div>
      <span class="material-symbols-outlined" style="cursor: pointer;" @click="$emit('close')" title="Close">close</span>
    </template>
    <template #body>
      <div ref="layoutWrapper" class="modal-layout-wrapper" :class="{ 'without-preview': withoutPreview }">
        <div v-if="!withoutPreview" v-show="sidebarWidth < maxWidth" class="main-content-area" :style="{ flex: sidebarWidth === 0 ? '1 1 100%' : '1' }">
          <div class="timetable-area-wrapper">
            <TimetablePreview 
              ref="timetableRef"
              :loading="isLoadingSchedule"
              :error-message="previewError"
              :modules="allTimetableModules"
              :modules-without-sessions="modulesWithoutSessions"
              :program-modules="program.modules"
              :external-highlight="hoveredModuleId"
              :preview-module-id="hoveredModuleId"
              :existing-modules="unmarkedCurrentSemesterModules"
              :sidebar-width="sidebarWidth"
              :overlaps="overlaps"
              :current-semester-ids="currentSemesterModules.map(m => m.id || m)"
              :semester-preferences="localSemesterPreferences"
              :desired-modules="markedModules"
              @openInfo= "(module) =>openModuleInfoModal(module, true)"
              @hover-module="hoveredModuleId = $event"
              @toggle-free-day="handleToggleFreeDay"
              @update-preference="handleUpdatePreference"
              @custom-session-changed="hasCommittedChanges = true"
              />
          </div>
          

        </div>

        <div v-if="!withoutPreview" class="resizer" :class="{ 'resizer-closed': sidebarWidth === 0 || sidebarWidth >= maxWidth }"
          @mousedown="startResize"
          @click.stop="toggleSidebar" 
          title="Drag to resize, click to toggle"
          >
          <span v-if="sidebarWidth === 0" class="material-symbols-outlined toggle-icon">chevron_left</span>
          <span v-else-if="sidebarWidth >= maxWidth" class="material-symbols-outlined toggle-icon">chevron_right</span>
        </div>

        <div class="right-sidebar" :class="{ 'sidebar-full': sidebarWidth >= maxWidth }" :style="withoutPreview || sidebarWidth >= maxWidth ? {} : { width: sidebarWidth + 'px' }" v-show="withoutPreview || sidebarWidth > 0">
          
          <div v-if="this.$props.showInput" class="modal-entry sidebar-entry">
            <ModuleSearchDropdown 
              :groupedModules="groupedModules"
              :selectableModules="selectableModules"
              :hasStructureGroups="hasStructureGroups"
              :moduleInput="moduleInput"
              :showName="showName"
              :showLanguage="showLanguage"
              :showECTS="showECTS"
              :truncateName="!withoutPreview && sidebarWidth < maxWidth"
              :isInfoModalOpen="isModuleInfoModalOpen"
              :forceCloseDropdown="forceCloseDropdown"
              :currentSemester="currentSemester"
              @update:moduleInput="moduleInput = $event"
              @info-click="module => openModuleInfoModal(module, false)"
              @select-module="clickMarkModule"
              @hover-module="hoveredModuleId = $event"
            />
          </div>



          <div class="modal-result-sidebar">
            <transition-group class="module-list-vertical" name="fade" tag="div">
              <div v-for="module in displayedMarkedModules" 
              :key="module.id" 
              class="module-row"
              :class="{ 
                'highlight-active': hoveredModuleId === module.id,
                'marked-active': markedModules.includes(module.id),
                'mip-module': !markedModules.includes(module.id) && currentSemesterIds.includes(module.id)
              }"
              @mouseenter="hoveredModuleId = module.id"
              @mouseleave="hoveredModuleId = null"
              >
                      <div class="module-name-text" :title="module.name">{{ module.name }}</div>
                      <span class="module-id-badge" style="margin-left: 10px;">{{ module.mock || module.suppressId? '' : module.number }}</span>
                      <span class="ects-tag" v-if="module.ects != 0">{{ module.mock && this.oneModulePerMockName ? '' : `${module.ects} ECTS` }}</span>
                    <div class="right-control">
                      
                      <!-- Pin/Unpin Action -->
                      <div class="action-slot">
                          <span class="material-symbols-outlined action-icon" 
                               :class="markedModules.includes(module.id) ? 'check-icon' : 'unpinned-icon'"
                               :title="markedModules.includes(module.id) ? 'Unpin module' : 'Pin module'"
                               @click.stop="markedModules.includes(module.id) ? unmarkModule(module) : clickMarkModule($event, module)">push_pin</span>
                      </div>

                      <!-- Negative Action (Remove from suggestion) -->
                      <div class="action-slot">
                        <span class="material-symbols-outlined action-icon remove-icon" 
                            title="Remove from plan (Undesired)"
                            @click.stop="markUndesired(module)">delete_outline</span>
                      </div>
                      
                      <!-- Info Modal -->
                      <div class="material-symbols-outlined" 
                           :class="'info-icon-small'"
                           @click="() => openModuleInfoModal(module, true)"
                           :title="'Module Info'">
                           info
                      </div>
                    </div>
              </div>
            </transition-group>
            
            <div v-if="displayedMarkedModules.length === 0" class="empty-state">
              No modules selected
            </div>
          </div>
          
          
 
        </div>
        
      </div>
    </template>

    <template #footer >
      <div v-if="!withoutPreview" class="text-hint">
        <span>
          <strong>Important:</strong> Please verify timetable, in particular exercise sessions might be missing.
          <template v-if="modulesWithoutSessions.length > 0">
            Data for <span class="missing-modules-link" @click.stop="openUnscheduledList">{{ modulesWithoutSessions.length }} module(s)</span> is not available.
          </template>
        </span>      
      </div>
      <div v-if="withoutPreview" class="text-hint-2">
        <span>
          <strong>Note:&ensp;</strong>Modules not regularly offered are unavailable for selection. Instead, choose a 'Special Topic in ...' (math) or 'Module in ...' (other departments) placeholder if available.
        </span>      
      </div>
      <div class="footer-buttons">
          <button 
            class="final-button btn-discard" 
            @click="$emit('close')"
          >
            <span class="material-symbols-outlined btn-icon">undo</span>
            Discard changes
          </button>
          
          <button 
            class="final-button btn-confirm-pinned-dark" 
            @click="confirmPinnedOnly"
            :disabled="!changeDetected"
            title="Confirm current selections and removals"
          >
            <span class="material-symbols-outlined btn-icon">check</span>
            Confirm pinned modules
          </button>

          <button 
            class="final-button btn-confirm-pinned-dark"
            @click="confirmFullTimetable"
            title="Pin everything currently visible in the timetable (Pinned + Suggested)"
          >
            <span class="material-symbols-outlined btn-icon">done_all</span>
            Confirm whole timetable
          </button>
      </div>
    </template>
  </base-modal>

  <SemesterSettingsModal
    :is-open="isOpen && showSettings"
    :semester="currentSemester"
    @close="showSettings = false"
    @apply="showSettings = false; $emit('close')"
  />

  <base-modal
    :is-open="showFreeDayDisclaimer"
    icon-modal="info"
    modal-title="Free day"
    :confirmation-required="true"
    text-confirm="I understand"
    :discarding-offered="true"
    text-discard="Cancel"
    :close-on-confirm="false"
    :closing-offered="true"
    :default-height="false"
    :body-gap="0"
    @beforeClose="cancelFreeDayToggle"
    @confirm="confirmFreeDayToggle"
    @reject="cancelFreeDayToggle"
  >
    <template #body>
      <div>
        <p style="margin: 0; line-height: 1.5; font-size: 15px; color: #4b5563;">
          Marking a day as a free day means that <strong>no classes</strong> will be scheduled on that day (except for pinned modules).
        </p>
        <div v-if="modulesToUnmark.length > 0" style="margin-top: 15px;">
          <p style="margin: 0 0 8px 0; font-weight: 600; font-size: 14px; color: #374151;">
            The following module(s) will be removed from this semester:
          </p>
          <ul style="margin: 0; padding-left: 20px; font-size: 14px; color: #4b5563; line-height: 1.4;">
            <li v-for="module in modulesToUnmark" :key="module.id">
              {{ module.name }} <span style="color: #9ca3af; font-size: 12px;">({{ module.number }})</span>
            </li>
          </ul>
        </div>
        <div v-if="pinnedModulesOnDay.length > 0" style="margin-top: 15px;">
          <p style="margin: 0 0 8px 0; font-weight: 600; font-size: 14px; color: #374151;">
            The following module(s) won't be removed from this semester since they are pinned:
          </p>
          <ul style="margin: 0; padding-left: 20px; font-size: 14px; color: #4b5563; line-height: 1.4;">
            <li v-for="module in pinnedModulesOnDay" :key="module.id">
              {{ module.name }} <span style="color: #9ca3af; font-size: 12px;">({{ module.number }})</span>
            </li>
          </ul>
        </div>
        <div v-if="modulesToUnmark.length === 0 && pinnedModulesOnDay.length === 0" style="margin-top: 15px;">
          <p style="margin: 0; font-size: 14px; color: #6b7280; font-style: italic;">
            No modules are currently scheduled on this day.
          </p>
        </div>
      </div>
    </template>
  </base-modal>
  
</template>


<script>
import ModuleInfoModal from '@/components/modals/ModuleInfoModal.vue';
import ModuleSearchDropdown from '@/components/modals/ModuleSearchDropdown.vue';
import BaseModal from "@/components/modals/BaseModal.vue";
import TimetablePreview from '@/components/modals/TimetablePreview.vue';
import SemesterSettingsModal from './SemesterSettingsModal.vue';
import {mapActions, mapState, mapGetters} from "vuex";
import { reactive } from 'vue';
import {currentSemester as getCurrentSemester} from "@/utils";
import {
  prioritiesOfStructureElements,
  modulesWithStructures,
  selectedStructures,
  getSelectableModules,
  getGroupedModules,
  getStructureColorClass,
  getDependentModules
} from '@/utils/moduleGrouping';

export default {
  name: "SemesterModulesModal",
  components: {BaseModal,ModuleInfoModal,ModuleSearchDropdown,TimetablePreview,SemesterSettingsModal},
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: true
    },
    semester: {
      type: Number,
      default: null
    },
    withoutPreview: {
      type: Boolean,
      default: false
    },
    modalName: {
      type: String,
      default: "TimetableModal"
    },
    iconModal: {
      type: String,
      default: "calendar_month"
    },
    modalTitle: {
      type: String,
      default: ""
    },
    modalSubtitle: {
      type: String,
      default: "Select or remove modules to build your timetable"
    },
    modalClass: {
      type: String,
      default: "custom-wide-modal"
    }
  },
  emits: ['close', 'confirmOperation'],
  data() {
   return {
    ...this.initialData(),
    collapsedGroups: reactive({}),
    isModuleInfoModalOpen: false,
    openedInBaseModuleModal: false,
    selectedModule: null, 
    sidebarWidth: 440, 
    previousSidebarWidth: 440,
    isResizing: false,
    startX: 0,
    startSidebarWidth: 0,
    hasMoved: false,
    minOpenWidth: 290, 
    snapThreshold: 250,
    maxWidth: 600,
    hoveredModuleId: null,
    activeOverlapPopupModuleId: null,
    localSemesterPreferences: {},
    localUndesiredForSemModules: [],
    dismissedMipModuleIds: [],
    isConfirming: false,
    hasCommittedChanges: false,
    previewError: null,
    oneModulePerMockName: false,
    showFreeDayDisclaimer: false,
    modulesToUnmark: [],
    pinnedModulesOnDay: []
  };
  },
  computed: {
    currentSemester() {
      return this.semester !== null ? this.semester : getCurrentSemester(this.preferences);
    },
    ...mapGetters(["requiredModules", "mockModules"]),
    ...mapState(["program", "preferences", "currentModal", "isLoadingSchedule", "schedule", "hasSolution", "errorOccurred", "offeredSemesters"]),
    schedule() {
      return this.$store.state.schedule;
    },
    currentSemesterIds() {
       if (!this.schedule || !this.schedule[this.currentSemester] || !this.schedule[this.currentSemester].modules) {
        return [];
      }
      return this.schedule[this.currentSemester].modules.map(m => (typeof m === 'object' ? m.id : m));
    },
    defaultTitle() {
      return "Timetable for " + (this.semesterDescription?.toLowerCase() ?? "");
    },
    hiddenModules() {
      const mocks = this.program.modules.filter((m)=>(this.mockModules.includes(m.id) && m.departmentMa==true)).map(m=>m.id);
      if (this.currentSemester !== 1) {
        return this.preferences.passedModules
            .concat(this.preferences.undesiredModules);
      } else {
        return this.preferences.passedModules
            .concat(this.preferences.undesiredModules).concat(mocks);
      }
    },
    selectableModules() {
      return getSelectableModules(this.program, this.preferences, {
        markedModules: this.markedModules,
        hiddenModules: this.hiddenModules,
        mockModules: this.mockModules,
        excludeDepartmentMaMock: true,
        moduleInput: this.moduleInput
      });
    },
    prioritiesOfStructureElements() {
      return prioritiesOfStructureElements(this.program, this.preferences);
    },
    modulesWithStructures() {
      return modulesWithStructures(this.program, this.preferences, this.prioritiesOfStructureElements);
    },
    selectedStructures() {
      return selectedStructures(this.program, this.preferences);
    },
    groupedModules() {
      return getGroupedModules(this.program, this.preferences, {
        selectableAvailableModules: this.selectableAvailableModules,
        selectableUnavailableModules: this.selectableUnavailableModules,
        modulesWithStructures: this.modulesWithStructures,
        targetSemester: this.currentSemester
      });
    },
    hasStructureGroups() {
      return this.groupedModules.some(group => group.structure && !group.isUnavailable);
    },
    unavailableModules() {
      return Object.entries(this.offeredSemesters)
          .filter(([, semesters]) => !semesters.includes(this.currentSemester))
          .map(([moduleId]) => moduleId);
    },
    selectableAvailableModules() {
      return this.selectableModules.filter(module => 
        !this.unavailableModules.includes(module.id)
      );
    },
    selectableUnavailableModules() {
      return this.selectableModules.filter(module => 
        this.unavailableModules.includes(module.id)
      );
    },
    displayedMarkedModules() {
      const sem1Ids = this.currentSemesterIds.filter(id => !this.localUndesiredForSemModules.includes(id) && !this.dismissedMipModuleIds.includes(id));
      const filteredMarked = this.markedModules.filter(id => !this.localUndesiredForSemModules.includes(id));
      const combined = [...new Set([...filteredMarked, ...sem1Ids])];
      let markedModules = this.program.modules.filter(module => {
        if (!combined.includes(module.id)) return false;
        if (filteredMarked.includes(module.id)) return true;
        return !this.isModuleOnFreeDay(module.id);
      });


      if (!this.oneModulePerMockName) {
        return markedModules.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      }

      // Only return modules that are unique in their name, but are not removed from marked while Modal has been open
      const uniqueModuleNames = new Set();
      return markedModules.filter(module => {
        const isUnique = !uniqueModuleNames.has(module.name);

        if (isUnique) {
          uniqueModuleNames.add(module.name);
          return true;
        }

        return false;
      });
    },

    changeDetected() {
      if (this.hasCommittedChanges || this.localUndesiredForSemModules.length > 0) {
        return true;
      }

      let initialMarked = [];
      if (this.$store && this.$store.state && this.$store.state.preferences) {
        initialMarked = Object.entries(this.$store.state.preferences.desiredInSemModules)
            .filter(([,semester]) => semester == this.currentSemester)
            .map(([moduleId]) => moduleId);
      }

      if (initialMarked.length !== this.markedModules.length) {
        return true;
      }

      let countMap = {};

      // Count the occurrences of each string in the initial array
      for (let i = 0; i < initialMarked.length; i++) {
        countMap[initialMarked[i]] = (countMap[initialMarked[i]] || 0) + 1;
      }

      // Subtract the count for each string in the current marked modules array
      for (let i = 0; i < this.markedModules.length; i++) {
        if (!countMap[this.markedModules[i]]) {
          return true; // string found in this.markedModules that's not in initialMarked
        }
        countMap[this.markedModules[i]]--;
      }

      // Check if all counts are back to zero
      for (let key in countMap) {
        if (countMap[key] !== 0) {
          return true;
        }
      }

      // Check for changes in semester preferences
      if (this.localSemesterPreferences) {
        const storePrefs = this.preferences.semesterPreferences && this.preferences.semesterPreferences[this.currentSemester] 
            ? this.preferences.semesterPreferences[this.currentSemester] 
            : { default: false };
            
        // Compare keys from local with store
        for (const key of Object.keys(this.localSemesterPreferences)) {
            if (this.localSemesterPreferences[key] !== storePrefs[key]) {
                return true;
            }
        }
      }

      return false;
    },

    currentSemesterModules() {
      if (!this.schedule || !this.schedule[this.currentSemester] || !this.schedule[this.currentSemester].modules) {
        return [];
      }
      return this.schedule[this.currentSemester].modules;
    },
    unmarkedCurrentSemesterModules() {
      return this.currentSemesterModules.filter(m => {
        const id = typeof m === 'object' ? m.id : m;
        return !this.markedModules.includes(id) && !this.localUndesiredForSemModules.includes(id) && !this.dismissedMipModuleIds.includes(id) && !this.isModuleOnFreeDay(id);
      });
    },

    allTimetableModules() {
      const sem1Ids = this.currentSemesterIds.filter(id => !this.localUndesiredForSemModules.includes(id) && !this.dismissedMipModuleIds.includes(id));
      const filteredMarked = this.markedModules.filter(id => !this.localUndesiredForSemModules.includes(id));
      const combined = [...new Set([...filteredMarked, ...sem1Ids])];
      return combined.filter(id => filteredMarked.includes(id) || !this.isModuleOnFreeDay(id));
    },
    overlaps() {
        const collisions = {};
        
        // If global overlap is allowed (ignoreTimetable), do not calculate warnings
        if (this.preferences.ignoreTimetable) {
             return collisions;
        }

        // Populate collisions object with boolean false initially
        this.program.modules.forEach(m => collisions[m.id] = false);

        // Get full module objects for all timetable modules
        const activeModules = this.allTimetableModules.map(id => 
             this.program.modules.find(m => m.id === id)
        ).filter(Boolean);

        for (let i = 0; i < activeModules.length; i++) {
            for (let j = i + 1; j < activeModules.length; j++) {
                const m1 = activeModules[i];
                const m2 = activeModules[j];
                
                if (this.checkModuleOverlap(m1, m2)) {
                    collisions[m1.id] = true;
                    collisions[m2.id] = true;
                }
            }
        }
        return collisions;
    },
    modulesWithoutSessions() {
      const moduleIds = this.allTimetableModules;
      const noSessions = [];
      moduleIds.forEach(moduleId => {
        const module = this.program.modules.find(m => m.id === moduleId);
        if (module && (!module.sessions || module.sessions.length === 0)) {
          noSessions.push(module);
        }
      });
      return noSessions;
    },
    showLanguage() {
      return this.withoutPreview || this.sidebarWidth >= 440;
    },
    showName() {
      return this.withoutPreview || this.sidebarWidth >= 200;
    },
    showECTS() {
      return this.withoutPreview || this.sidebarWidth >= 160;
    },
    semesterDescription() {
      const semesterSchedule = this.schedule[this.currentSemester.toString()];
      return semesterSchedule ? semesterSchedule.semesterDescription : "null";
    },

    totalECTS() {
      return this.allTimetableModules.reduce((sum, id) => {
        const module = this.program.modules.find(m => m.id === id);
        return sum + (module ? module.ects : 0);
      }, 0);
    },
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.cleanModal();
        this.$nextTick(() => {
          this.updateMaxWidth();
        });
      }
    },
    isLoadingSchedule(newVal, oldVal) {
      if (!newVal && oldVal) {
        if (this.isConfirming) {
          this.previewError = null;
          this.cleanModal();
          this.isConfirming = false;
        }
      }
    },
    currentModal(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== this.modalName) {
        this.cleanModal();
      }
    },
    'preferences.semesterPreferences': {
      handler(newVal) {
        const targetSem = this.semester !== null ? this.semester : getCurrentSemester(this.preferences);
        if (newVal && newVal[targetSem]) {
          this.localSemesterPreferences = JSON.parse(JSON.stringify(newVal[targetSem]));
        }
      },
      deep: true
    }
  },
  created() {
    if (this.preferences && this.preferences.semesterPreferences && this.preferences.semesterPreferences[this.currentSemester]) {
      this.localSemesterPreferences = JSON.parse(JSON.stringify(this.preferences.semesterPreferences[this.currentSemester]));
    } else {
      this.localSemesterPreferences = {};
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleGlobalKeyDown, true);
    window.addEventListener('resize', this.updateMaxWidth);
    this.$nextTick(() => {
      this.updateMaxWidth();
    });
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleGlobalKeyDown, true);
    window.removeEventListener('resize', this.updateMaxWidth);
  },
  methods: {
    handleGlobalKeyDown(e) {
        if (e.key === 'Delete' || e.key === 'Backspace') {
            const tag = e.target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA') return;
            e.stopPropagation();
        }
    },
    ...mapActions(["openModal"]),
    handleToggleFreeDay(day) {
        if (!this.localSemesterPreferences) {
            this.localSemesterPreferences = { default: false };
        }
        const capitalizedDay = day.charAt(0).toUpperCase() + day.substring(1, 3).toLowerCase();
        const key = 'free' + capitalizedDay;

        const isCurrentlyFree = !!this.localSemesterPreferences[key];

        // Free day disclaimer should only appear if there is at least one module on that day
        if (!isCurrentlyFree) {
            const { unpinnedModules, pinnedModules } = this.calculateModulesForFreeDay(day);
            if (unpinnedModules.length > 0 || pinnedModules.length > 0) {
                this.pendingFreeDayToggle = day;
                this.modulesToUnmark = unpinnedModules;
                this.pinnedModulesOnDay = pinnedModules;
                this.showFreeDayDisclaimer = true;
                return;
            } else {
                this.localSemesterPreferences = {
                    ...this.localSemesterPreferences,
                    [key]: true
                };
                this.hasCommittedChanges = true;
                return;
            }
        }

        // Toggle property (disabling free day / enabling the day again)
        this.localSemesterPreferences = {
            ...this.localSemesterPreferences,
            [key]: false
        };
        this.hasCommittedChanges = true;
    },
    confirmFreeDayToggle() {
        if (this.pendingFreeDayToggle) {
            const day = this.pendingFreeDayToggle;
            const capitalizedDay = day.charAt(0).toUpperCase() + day.substring(1, 3).toLowerCase();
            const key = 'free' + capitalizedDay;

            this.localSemesterPreferences = {
                ...this.localSemesterPreferences,
                [key]: true
            };
            if (this.modulesToUnmark && this.modulesToUnmark.length > 0) {
                this.modulesToUnmark.forEach(module => {
                    const id = module.id || module;
                    if (!this.dismissedMipModuleIds.includes(id)) {
                        this.dismissedMipModuleIds.push(id);
                    }
                });
            }
            this.hasCommittedChanges = true;
            sessionStorage.setItem('studyplanner_free_day_disclaimer_shown', 'true');
        }
        this.showFreeDayDisclaimer = false;
        // Reset state after transition finishes to avoid VNode patching issues
        setTimeout(() => {
            this.pendingFreeDayToggle = null;
            this.modulesToUnmark = [];
            this.pinnedModulesOnDay = [];
        }, 300);
    },
    cancelFreeDayToggle() {
        this.showFreeDayDisclaimer = false;
        setTimeout(() => {
            this.pendingFreeDayToggle = null;
            this.modulesToUnmark = [];
            this.pinnedModulesOnDay = [];
        }, 300);
    },
    calculateModulesForFreeDay(day) {
      const normalizedTargetDay = this.normalizeDayName(day);
      const unpinnedModules = [];
      const pinnedModules = [];

      // Non-pinned MIP modules assigned to current semester
      const sem1MipIds = this.currentSemesterIds.filter(id => 
        !this.localUndesiredForSemModules.includes(id) && 
        !this.dismissedMipModuleIds.includes(id) && 
        !this.markedModules.includes(id)
      );

      sem1MipIds.forEach(moduleId => {
        const module = this.program.modules.find(m => m.id === moduleId);
        if (!module) return;

        const hasRegularSessionOnDay = module.sessions && module.sessions.some(session => 
          this.normalizeDayName(session.day) === normalizedTargetDay
        );

        const customSessions = this.$store.state.preferences.customSessions || [];
        const hasCustomSessionOnDay = customSessions.some(session => 
          (session.moduleId === module.id || session.module_id === module.id) && 
          this.normalizeDayName(session.day) === normalizedTargetDay
        );

        if (hasRegularSessionOnDay || hasCustomSessionOnDay) {
          unpinnedModules.push(module);
        }
      });

      // Pinned modules
      const filteredMarked = this.markedModules.filter(id => !this.localUndesiredForSemModules.includes(id));

      filteredMarked.forEach(moduleId => {
        const module = this.program.modules.find(m => m.id === moduleId);
        if (!module) return;

        const hasRegularSessionOnDay = module.sessions && module.sessions.some(session => 
          this.normalizeDayName(session.day) === normalizedTargetDay
        );

        const customSessions = this.$store.state.preferences.customSessions || [];
        const hasCustomSessionOnDay = customSessions.some(session => 
          (session.moduleId === module.id || session.module_id === module.id) && 
          this.normalizeDayName(session.day) === normalizedTargetDay
        );

        if (hasRegularSessionOnDay || hasCustomSessionOnDay) {
          pinnedModules.push(module);
        }
      });

      return { unpinnedModules, pinnedModules };
    },
    isModuleOnFreeDay(moduleId) {
      if (!this.localSemesterPreferences) return false;
      const module = this.program.modules.find(m => m.id === moduleId);
      if (!module) return false;

      // Find all free days in localSemesterPreferences
      const freeDays = ['mon', 'tue', 'wed', 'thu', 'fri'].filter(day => {
        const capitalizedDay = day.charAt(0).toUpperCase() + day.substring(1, 3).toLowerCase();
        const key = 'free' + capitalizedDay;
        return !!this.localSemesterPreferences[key];
      });

      if (freeDays.length === 0) return false;

      // Check if any regular session is on any of the free days
      const hasRegularSessionOnFreeDay = module.sessions && module.sessions.some(session => {
        const sessionDay = this.normalizeDayName(session.day).substring(0, 3).toLowerCase();
        return freeDays.includes(sessionDay);
      });

      // Check if any custom session for this module is on any of the free days
      const customSessions = this.$store.state.preferences.customSessions || [];
      const hasCustomSessionOnFreeDay = customSessions.some(session => {
        if (session.moduleId !== module.id && session.module_id !== module.id) return false;
        const sessionDay = this.normalizeDayName(session.day).substring(0, 3).toLowerCase();
        return freeDays.includes(sessionDay);
      });

      return hasRegularSessionOnFreeDay || hasCustomSessionOnFreeDay;
    },
    unmarkModulesOnDay() {
      // Pinned modules are no longer automatically unmarked on free days
    },
    handleUpdatePreference({ key, value }) {
        if (!this.localSemesterPreferences) {
            this.localSemesterPreferences = { default: false };
        }
        this.localSemesterPreferences = {
            ...this.localSemesterPreferences,
            [key]: value
        };
    },
    checkModuleOverlap(m1, m2) {
        if (!m1.sessions || !m2.sessions ) return false;
        if (m1.id === m2.id) return false;
        return m1.sessions.some(s1 => 
            m2.sessions.some(s2 => this.isSessionOverlapping(s1, s2))
        );
    },


    normalizeDayName(day) {
        if (!day) return '';
        const d = day.toLowerCase();
        if(d.includes('mon')) return 'Monday';
        if(d.includes('tue')) return 'Tuesday';
        if(d.includes('wed')) return 'Wednesday';
        if(d.includes('thu')) return 'Thursday';
        if(d.includes('fri')) return 'Friday';
        return day;
    },
    isSessionOverlapping(s1, s2) {
        if (this.normalizeDayName(s1.day) !== this.normalizeDayName(s2.day)) return false;
        
        const start1 = this.timeToMinutes(s1.startTime);
        const end1 = this.timeToMinutes(s1.endTime);
        const start2 = this.timeToMinutes(s2.startTime);
        const end2 = this.timeToMinutes(s2.endTime);
        
        // Strict inequality to allow adjacent sessions (e.g. 10-12 and 12-14)
        return Math.max(start1, start2) < Math.min(end1, end2);
    },
    timeToMinutes(timeStr) {
      if (!timeStr) return 0;
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    },
    initialData() {
      let initialMarked = [];
      if (this.$store && this.$store.state && this.$store.state.preferences) {
        const targetSem = this.semester !== null ? this.semester : getCurrentSemester(this.preferences);
        initialMarked = Object.entries(this.$store.state.preferences.desiredInSemModules)
            .filter(([,semester]) => semester === targetSem)
            .map(([moduleId]) => moduleId);
      }
      return {
        moduleInput: "",
        showDropdown: false,
        markedModules: initialMarked,
        message: '',
        fadeOut: false,
        forceCloseDropdown: false,
        showSettings: false,
        pendingFreeDayToggle: null,
        modulesToUnmark: []
      };
    },
    toggleLocalDefaultSettings() {
      if (!this.localSemesterPreferences) {
        this.localSemesterPreferences = { default: false };
      }
      if (this.localSemesterPreferences.default) {
        this.localSemesterPreferences.default = false;
        this.localSemesterPreferences.minEcts = this.preferences.minEctsPerSemester;
        this.localSemesterPreferences.maxEcts = this.preferences.maxEctsPerSemester;
        this.localSemesterPreferences.minExams = this.preferences.minExamsPerSemester;
        this.localSemesterPreferences.maxExams = this.preferences.maxExamsPerSemester;
      } else {
        this.localSemesterPreferences.default = true;
        this.localSemesterPreferences.minEcts = this.preferences.minEctsPerSemester;
        this.localSemesterPreferences.maxEcts = this.preferences.maxEctsPerSemester;
        this.localSemesterPreferences.minExams = this.preferences.minExamsPerSemester;
        this.localSemesterPreferences.maxExams = this.preferences.maxExamsPerSemester;
      }
      this.hasCommittedChanges = true;
    },
    toggleLocalFreeDay(day) {
      if (!this.localSemesterPreferences) {
        this.localSemesterPreferences = { default: false };
      }
      const capitalizedDay = day.charAt(0).toUpperCase() + day.substring(1, 3).toLowerCase();
      const key = 'free' + capitalizedDay;
      const willBeFree = !this.localSemesterPreferences[key];
      this.localSemesterPreferences = {
        ...this.localSemesterPreferences,
        [key]: willBeFree
      };
      if (willBeFree) {
        const { unpinnedModules } = this.calculateModulesForFreeDay(day);
        unpinnedModules.forEach(module => {
          const id = module.id || module;
          if (!this.dismissedMipModuleIds.includes(id)) {
            this.dismissedMipModuleIds.push(id);
          }
        });
      }
      this.hasCommittedChanges = true;
    },
    confirmPinnedOnly() {
       // Only confirm with markedModules (the Green ones)
       this.handleConfirm(this.markedModules);
    },
    confirmFullTimetable() {
       // Confirm with all displayed modules (Green + Blue)
       const currentVisibleMIPModules = this.currentSemesterIds.filter(id => 
          !this.markedModules.includes(id) &&
          !this.localUndesiredForSemModules.includes(id) &&
          !this.dismissedMipModuleIds.includes(id) &&
          !this.isModuleOnFreeDay(id)
       );
       this.setMaxECTS();
       const allModulesToPin = [...this.markedModules, ...currentVisibleMIPModules];
       this.handleConfirm(allModulesToPin);
    },
    handleConfirm(modulesToSave) {
        // Handle local preferences
        if (this.localSemesterPreferences) {
          Object.keys(this.localSemesterPreferences).forEach(key => {
              this.$store.commit("UPDATE_SEMESTER_PREFERENCE", { 
                  semester: this.currentSemester, 
                  key: key, 
                  value: this.localSemesterPreferences[key],
                  bulk: true
              });
          });
        }
        // Handle dynamically pinning and unpinning modules
        const previouslyPinned = Object.entries(this.$store.state.preferences.desiredInSemModules)
            .filter(([,semester]) => semester === this.currentSemester)
            .map(([moduleId]) => moduleId);

        const modulesToRemove = previouslyPinned.filter(module => !modulesToSave.includes(module));
        const modulesToAdd = modulesToSave.filter(module => !previouslyPinned.includes(module));

        modulesToRemove.forEach(module => {
            this.$store.commit("REMOVE_DESIRED_IN_SEM_MODULE", {desiredInSemModule:module, bulk : true});
            this.$store.commit("REMOVE_DESIRED_MODULE", {desiredModule:module,bulk : true});
        });

        modulesToAdd.forEach(module => {
            this.$store.commit("ADD_DESIRED_IN_SEM_MODULE", {module: module, semester: this.currentSemester, bulk: true});
        });

        this.localUndesiredForSemModules.forEach(module => {
            this.$store.commit("ADD_UNDESIRED_IN_SEM_MODULE", {module: module, semester: this.currentSemester, bulk: true});
        });

        this.$store.commit("SAVE_STATE");

        this.isConfirming = true;
        this.$emit("confirmOperation", modulesToSave);
        this.reload();
        this.$emit('close');
    },
    setMaxECTS() {
        if (!this.localSemesterPreferences) {
            this.localSemesterPreferences = {};
        }
        this.localSemesterPreferences = {
            ...this.localSemesterPreferences,
            default: false,
            maxEcts: this.totalECTS
        };
    },
    clickMarkModule(event, module) {
      if ((event=='infomodal' || event.button === 0 )) { 
        this.markModule(module);
        // If it was in localUndesiredForSemModules, remove it from there (undo delete)
        if (this.localUndesiredForSemModules.includes(module.id)) {
            this.localUndesiredForSemModules = this.localUndesiredForSemModules.filter(id => id !== module.id);
        }
        if (this.dismissedMipModuleIds.includes(module.id)) {
            this.dismissedMipModuleIds = this.dismissedMipModuleIds.filter(id => id !== module.id);
        }
        
        this.message = `Module added`;
        this.fadeOut = false;

        setTimeout(() => {
          this.fadeOut = true;
          setTimeout(() => {
            this.message = '';
          }, 0);
        }, 500);
        this.moduleInput = "";

        this.forceCloseDropdown = true;
        setTimeout(() => { this.forceCloseDropdown = false; }, 100);
      }
    },
    markModule(module) {
      if (this.hoveredModuleId === module.id) {
        this.hoveredModuleId = null;
      }
      if (!this.markedModules.includes(module.id)) {
        this.markedModules.push(module.id);
      }

      // If there are submodules, and they are not already selected, add them to the addedModules list
      if (module.submodules.length > 0) {
        module.submodules.forEach(submodule => {
          if (!this.markedModules.includes(submodule)) {
            this.markedModules.push(submodule);
          }
        });
      }

      // mark parent module if min number of marked submodules fulfilled
      if (module.submodule) {
        // find parent module
        const parentModule = this.program.modules.find(module => module.submodules.includes(module.id))
        if (!parentModule) return;
        // check if condition is fulfilled
        const numChildrenSelected = this.markedModules.filter(item => parentModule.submodules.includes(item)).length;
        if (!this.markedModules.includes(parentModule.id) && numChildrenSelected >= parentModule.numRequiredSubmodules) {
          this.markedModules.push(parentModule.id);
        }
      }

      // If there are dependent modules, also add them
      const dependees = this.getDependentModules(module)
      if (dependees) {
        dependees.forEach(dependee => {
          if (!this.markedModules.includes(dependee.id)) {
            this.markedModules.push(dependee.id);
          }
        });
      }
      setTimeout(() => {
            if (this.hoveredModuleId == module.id){
              this.hoveredModuleId =null
            }
          }, 3000);
    },
    unmarkModule(module) {
      if (this.hoveredModuleId === module.id) {
        this.hoveredModuleId = null;
      }
      if (!this.markedModules.includes(module.id)) {
        return
      }
      this.markedModules = this.markedModules.filter(mod => mod !== module.id);

      // unmark parent module if condition not fulfilled anymore, because of possible earlier auto-addition
      if (module.submodule) {
        // find parent module
        const parentModule = this.program.modules.find(module => module.submodules.includes(module.id))
        if (!parentModule) return;
        // check if condition still fulfilled
        const numChildrenSelected = this.markedModules.filter(item => parentModule.submodules.includes(item)).length;
        if (this.markedModules.includes(parentModule.id) && numChildrenSelected < parentModule.numRequiredSubmodules) {
          // unmark parent if condition not fulfilled anymore
          this.markedModules = this.markedModules.filter(mod => mod !== parentModule.id);
        }
      }
    },

    markUndesired(module) {
      if (!this.localUndesiredForSemModules.includes(module.id)) {
        this.localUndesiredForSemModules.push(module.id);
        if (this.hoveredModuleId === module.id) {
          this.hoveredModuleId = null;
        }
      }
    },

    getDependentModules(module) {
      return getDependentModules(module, this.program.modules);
    },
    structureColorClass(moduleId) {
      return getStructureColorClass(moduleId, this.modulesWithStructures);
    },
    moduleLocation(module) {
      /*/switch(module.sessions.length==0? '': module.sessions[0].location){
        case 'Garching':
          return 'GAR';
        case 'Straubing':
          return 'STR';
        case 'Ottobrunn':
          return 'OTT';
        case 'Freising':
          return 'FRE';
        case 'Hochbrueck':
          return 'HOB';
        case 'Munich':
          return 'MUC';
        default:
          return '';
      }/*/
      return module.sessions.length==0? '': module.sessions[0].location;
    },
    reload() {
      this.$store.dispatch("requestSchedule");
    },
    cleanModal() {
      Object.assign(this.$data, this.initialData());
      this.localUndesiredForSemModules = [];
      this.dismissedMipModuleIds = [];
      this.isConfirming = false;
      this.hasCommittedChanges = false;
      
      const isOpening = this.isOpen || (this.currentModal === this.modalName);
      if (isOpening) {
        this.showSettings = this.$store.state.openSettingsInModal || false;
        if (this.$store.state.openSettingsInModal) {
          this.$store.commit("SET_OPEN_SETTINGS_IN_MODAL", false);
        }
      } else {
        this.showSettings = false;
      }

      const targetSem = this.semester !== null ? this.semester : getCurrentSemester(this.preferences);
      if (this.preferences && this.preferences.semesterPreferences && this.preferences.semesterPreferences[targetSem]) {
        this.localSemesterPreferences = JSON.parse(JSON.stringify(this.preferences.semesterPreferences[targetSem]));
      } else {
        this.localSemesterPreferences = {};
      }
    },
    toggleGroup(groupId, event) {
      event.stopPropagation();
      event.preventDefault();
      
      this.collapsedGroups = {
        ...this.collapsedGroups,
        [groupId]: !this.collapsedGroups[groupId]
      };
    },
    isGroupCollapsed(group) {
      const groupId = (group.structure || group.isUnavailable) ? `structure-${group.structure.id}` : 'no-structure';
      return this.collapsedGroups[groupId] || false; 
    },
    getGroupId(group) {
      return (group.structure || group.isUnavailable) ? `structure-${group.structure.id}` : 'no-structure';
    },
    toggleFocusInput() {
      if (this.showDropdown) {
        this.showDropdown = false;
        this.$refs.input.blur();
      } else {
        this.$refs.input.focus();
      }
    },
    openModuleInfoModal(module,inBaseModuleModal) {
      this.selectedModule = module;
      this.currentModuleIndex = null;
      this.openedInBaseModuleModal = inBaseModuleModal;
      this.isModuleInfoModalOpen = true;
    },
    selectModule(moduleId) {
      this.clickMarkModule('infomodal', this.program.modules.find(module => module.id === moduleId));
      if (!this.openedInBaseModuleModal) {
        this.showDropdown = false;
      }
    },
    handleSpecifyModule({ mockModuleId, realModuleId, semester }) {
      if (mockModuleId) {
        this.$store.commit("REMOVE_DESIRED_IN_SEM_MODULE", { desiredInSemModule: mockModuleId, bulk: true });
        this.$store.commit("REMOVE_DESIRED_MODULE", { desiredModule: mockModuleId, bulk: true });
      }
      if (realModuleId) {
        this.$store.commit("REMOVE_UNDESIRED_MODULE", { undesiredModule: realModuleId, bulk: true });
      }
      const targetSem = semester || this.currentSemester;
      if (targetSem) {
        this.$store.commit('ADD_DESIRED_IN_SEM_MODULE', { module: realModuleId, semester: targetSem, bulk: true });
      } else {
        this.$store.commit('ADD_DESIRED_MODULE', { desiredModule: realModuleId, bulk: true });
      }
      this.$store.commit('SAVE_STATE');
      this.closeModuleInfoModal();
      this.reload();
    },
    closeModuleInfoModal() {
      this.isModuleInfoModalOpen = false;
      this.selectedModule = null;
      if (!this.openedInBaseModuleModal) {
        this.showDropdown = true;
        this.$nextTick(() => {
          if (this.$refs.input) {
            this.$refs.input.focus();
          }
        });
      }
    },
    updateMaxWidth() {
      if (this.$refs.layoutWrapper) {
        this.maxWidth = this.$refs.layoutWrapper.getBoundingClientRect().width - 25;
      } else if (typeof window !== 'undefined') {
        this.maxWidth = window.innerWidth - 100;
      }
    },
    startResize(event) {
      this.isResizing = true;
      this.startX = event.clientX;
      this.startSidebarWidth = this.sidebarWidth;
      this.hasMoved = false;
      
      this.updateMaxWidth();

      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);
      
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';
    },

    handleResize(event) {
      if (!this.isResizing) return;
      this.hasMoved = true;

      // Calculate offset from the start of the drag (Dragging Left increases width, Right decreases width)
      const offset = this.startX - event.clientX;
      const proposedWidth = this.startSidebarWidth + offset;

      // 1. Logic to SNAP TO CLOSE
      if (proposedWidth < this.snapThreshold) {
        if (this.sidebarWidth !== 0) {
           this.previousSidebarWidth = this.minOpenWidth; // Reset memory if manually closed via drag
           this.sidebarWidth = 0;
        }
      } 
      // 2. Logic to SNAP TO OPEN FULL
      else if (this.maxWidth - proposedWidth < 280) {
        if (this.sidebarWidth !== this.maxWidth) {
           this.previousSidebarWidth = this.sidebarWidth > 0 ? this.sidebarWidth : 440;
        }
        this.sidebarWidth = this.maxWidth;
      }
      // 3. Logic for NORMAL RESIZING
      else {
        this.sidebarWidth = proposedWidth;
      }
    },

    stopResize() {
      // Small timeout to prevent the 'click' event from firing immediately after a drag
      setTimeout(() => {
        this.isResizing = false;
      }, 50);
      
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
      
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    },
    toggleSidebar() {
      if (this.hasMoved) return;
      
      if (this.sidebarWidth === 0) {
        // Restore to previous width or default
        this.sidebarWidth = this.previousSidebarWidth < this.minOpenWidth 
          ? this.minOpenWidth 
          : this.previousSidebarWidth;
      } else if (this.sidebarWidth >= this.maxWidth) {
        // Snapped all the way to the left, restore to previous width or default
        this.sidebarWidth = (this.previousSidebarWidth >= this.maxWidth || this.previousSidebarWidth < this.minOpenWidth)
          ? 440 
          : this.previousSidebarWidth;
      } else {
        return;
      }
    },
    /*triggerPdfDownload() {
    if (this.$refs.timetableRef) {      
      this.sidebarWidth = 0;
      this.$refs.timetableRef.downloadTimetablePDF(); 
    }
    },*/
    openEdit(){
      if (this.$refs.timetableRef) { 
      this.$refs.timetableRef.openEditTimetable();
      }
    },
    openUnscheduledList() {
      if (this.$refs.timetableRef) {
        this.$refs.timetableRef.showUnscheduledList = !this.$refs.timetableRef.showUnscheduledList;
      }
    },
    isRequired(moduleId) {
      return this.requiredModules.some(module => module === moduleId);
    }
  },
};
</script>

<style scoped>

.modal-result {
  flex-grow: 1;
  border: 1px dashed #bbb;
  border-radius: 4px;
  padding: 10px;
  overflow-y: auto;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); 
  gap: 10px;
  justify-content: center;
  font-size: 80%;
}

.module {
  min-width: 0; 
  height: 80px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  position: relative;
}

.icon-container {
  display: flex;
  align-items: center;
}

.material-symbols-outlined {
  font-size: 18px;
}

.module .material-symbols-outlined {
  cursor: pointer;
  color: #333333;
  transition: color 0.3s;
}

.module .material-symbols-outlined:hover {
  color: #6A757E;
}


.module-content {
  display: flex;
  height: 100%;
}

.left-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}



.text-hint {
  position:relative;
  overflow-y: hidden;
  width: 55%;
  margin-top: -65px;
  margin-left: 15px;
  top: 50px;
  overflow: hidden;
  font-size: 90%;
  line-height: 1.5em;
}
.missing-modules-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}
.missing-modules-link:hover {
  color: #115293;
}
.text-hint-2 {
  flex: 1;
  text-align: left;
  font-size: 85%;
  line-height: 1.4em;
  align-self: center;
  white-space: normal !important;
  max-width: 45%;
  margin: 0;
}
.text-hint-2 * {
  white-space: normal !important;
}

@media (max-width: 1000px), (max-height: 300px) {
  .text-hint {
    display: none;
  }
}

.message-wrapper {
  position: absolute;
  width: auto;
  display: flex;
  justify-content: center;
  pointer-events: none;
  z-index: 1000;
  transition: all 0.5s ease;
  bottom: calc(67% + 80px);
  left: 50%;
  transform: translateX(-50%);
}

.message {
  color: #000;
  background-color: #9ABCE4;
  border-radius: 8px;
  padding: 6px 16px;
  transform: translateY(160px);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 1;
  transition: opacity 0.5s;
  pointer-events: auto;
  font-size: 12px;
  font-family: inherit;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}
.check-icon {
  color: #4caf50 ;
  cursor: pointer;
  font-size: 18px;
  transition: color 0.2s;
}

.check-icon:hover {
  color: #388e3c;
  transform: scale(1.1);
}

.unpinned-icon {
  color: #bdbdbd; /* Gray */
  cursor: pointer;
  font-size: 18px;
  transition: color 0.2s, transform 0.2s;
}

.unpinned-icon:hover {
  color: #9e9e9e; /* Darker gray on hover */
  transform: scale(1.1);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-out {
  opacity: 0; /* Fade out effect */
}
/* Group headers */
.structure-header {
  background-color: #fff8f2;  
  color: #e65100;            
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  user-select: none;
}

.structure-header:hover {
  background-color: #ffebd8;  
}

.header-text {
  flex-grow: 1;
}

.expand-icon {
  color: #e65100;
  font-size: 20px;
  margin-left: 8px;
  transition: transform 0.2s ease;
  pointer-events: none; 
}

.info-icon {
  cursor: pointer;
  opacity: 0.6;
  font-size: 22px !important;
  vertical-align: middle;
  z-index: 900;
  flex-shrink: 0; 
}


.suggestion-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px 10px 24px; 
  border-bottom: 1px solid #f5f5f5;
  background-color: white;
  gap: 10px; 
  overflow: hidden;
}

.suggestion-item:hover {
  background-color: #f9f9f9;
}

.module-info-height {
  max-height: 80vh;
  overflow-y: auto;
  width: 600px;
  max-width: 90%;
}

.modal-body {
  padding: 20px;
}

.modal-body h3 {
  margin-top: 15px;
  margin-bottom: 5px;
  color: #333;
  font-size: 16px;
}

.modal-body p {
  margin-top: 0;
  line-height: 1.5;
}

.module-description,
.module-lecturer,
.module-semester,
.module-requirements,
.module-content {
  margin-bottom: 15px;
}

.modal-layout-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;     
  gap: 20px;
  overflow: visible;
  box-sizing: border-box;
  width: 100%;
}


.main-content-area {
  flex: 1; 
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-top: -35px;
}


.right-sidebar {
  height: 100%;     
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  flex-shrink: 0;
  overflow: visible; 
  position: relative;
  box-sizing: border-box;
  min-width: 0;
}

.right-sidebar.sidebar-full {
  flex: 1;
  width: 100% !important;
  min-width: 0;
  padding-left: 0;
}

.right-sidebar * {
  white-space: nowrap; 
}

.sidebar-entry {
  margin-bottom: 10px;
  margin-top: 5px;
  width: 100%;
  box-sizing: border-box;
}

.timetable-area-wrapper {
  flex: 1;           
  min-height: 0;     
  margin-top: 5px;   
  margin-bottom: 0px;
  position: relative;
  display: flex;      
  flex-direction: column;
}
.modal-result-sidebar {
  flex-grow: 1;  
  height: 0;     
  min-height: 0; 
  
  overflow-y: auto; 
  overflow-x: hidden;
  scrollbar-width: thin;
  
  padding-right: 5px;
  border-top: 1px solid #eee;
  padding-top: 10px;
  margin-top: 5px;
  
  position: relative; 
  z-index: 1; 
  width: 100%;
  box-sizing: border-box;
}

.module-list-vertical {
  display: flex;
  flex-direction: column;
  gap: 0px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}

.module-card {
  background: white;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px;
  font-size: 0.9em;
  box-sizing: border-box;
}

.module-card .module-content {
  display: flex;
  justify-content: space-between;
}

.module-card .right-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}


.module-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 10px 2px 7px; 
  margin-bottom: 0px; 
  border-bottom: 1px solid #e0e0e0; 
  border-left: 3px solid transparent;
  background: white;
  min-height: 30px; 
  transition: all 0.2s;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
}

.module-row:last-child {
  border-bottom: none;
}

.module-row:hover {
  background-color: #fcfcfc;
}

.module-row.marked-active {
  background-color: #fff;
  border-left: 3px solid #4caf50;
}

.module-row.mip-module {
  background-color: #fff;
  border-left: 3px solid #666; 
}
.module-id-badge {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85em;
  font-weight: bold;
  color: #555;
  flex-shrink: 0; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80px;
}
.module-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  color: #333;
  flex: 1 100 auto; 
  min-width: 0; 
}

.ects-tag {
  font-size: 0.85em;
  color: #777;
  flex-shrink: 0; 
  white-space: nowrap;
  overflow: hidden; 
  margin-left: 10px;
}

.right-control {
  display: flex;
  align-items: center;
  gap: 4px; 
  flex-shrink: 0; 
  margin-left: 10px;
}

.action-slot {
  width: 24px; /* Fixed width for alignment */
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-icon {
  cursor: pointer;
  font-size: 18px;
  transition: color 0.2s;
}
.action-icon:hover {
  color: #333;
}
.remove-icon:hover {
  color: #d32f2f;
}
.secondary {
  background-color: #fff;
  color: #9ABCE4;
}
.secondary:hover:not(:disabled) {
  background-color: #f0f4f8;
}
.sidebar-header {
  font-weight: bold;
  margin-bottom: 10px;
  color: #555;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.remove-icon {
  color: #d32f2f;
  cursor: pointer;
  font-size: 18px;
}

.info-icon-small {
  color: #1976d2;
  cursor: pointer;
  font-size: 18px;
}

.module-name {
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: -5px;
  line-height: 1.2;

  overflow: ellipsis;
}
.module-name-bar {
  flex: 1; 
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  text-align: left;
}

.empty-state {
  text-align: center;
  color: #999;
  margin-top: 30px;
  font-style: italic;
  font-size: 0.9em;
}

.resizer {
  width: 5px; 
  cursor: col-resize; 
  background-color: #f5f5f5;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  transition: background-color 0.2s;
  flex-shrink: 0; 
  z-index: 50;
  
 
  display: flex;
  align-items: center;
  justify-content: center;
}

.resizer:hover, .resizer:active {
  background-color: #9abce4; 
}

.resizer-closed {
  cursor: pointer;
  background-color: #f0f0f0;
} 

.right-control {
  display: flex;
  align-items: center;
  gap: 8px; /* Ensure space between side-by-side icons */
}

.sidebar-header {
  font-weight: bold;
  margin-bottom: 10px;
  color: #555;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.remove-icon {
  color: #d32f2f;
  cursor: pointer;
  font-size: 18px;
}

.info-icon-small {
  color: #1976d2;
  cursor: pointer;
  font-size: 18px;
}

.module-name {
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: -5px;
  line-height: 1.2;

  overflow: ellipsis;
}
.module-name-bar {
  flex: 1; 
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  text-align: left;
}

.empty-state {
  text-align: center;
  color: #999;
  margin-top: 30px;
  font-style: italic;
  font-size: 0.9em;
}

.resizer {
  width: 5px; 
  cursor: col-resize; 
  background-color: #f5f5f5;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  transition: background-color 0.2s;
  flex-shrink: 0; 
  z-index: 50;
  
 
  display: flex;
  align-items: center;
  justify-content: center;
}

.resizer:hover, .resizer:active {
  background-color: #9abce4; 
}

.resizer-closed {
  cursor: pointer; 
  background-color: #f0f0f0;
}

.resizer-closed:hover {
  background-color: #9abce4;
}

.modal-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  cursor: pointer;
  margin-right: 20px;
}

.modal-controls .material-symbols-outlined {
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 22px;
}

.modal-controls .material-symbols-outlined:hover {
  background-color: #eee;
}

.header-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #555;
}

.header-action-btn:hover {
  background-color: #e3f2fd; 
  color: #1976d2;
}

.header-action-btn .material-symbols-outlined {
  font-size: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter-from, .fade-leave-to { 
  opacity: 0;
  transform: translateX(-10px); 
}


.highlight-active {
  transform: translateX(-4px);
  background-color: #fcfcfc;
}

.module-row.marked-active.highlight-active {
  background-color: #fcfcfc; 
}



.warning-icon-small {
  color: #c62828 !important;
  font-size: 18px !important;
  cursor: pointer;
  animation: pulse 2s infinite;
  vertical-align: middle;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.footer-buttons {
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: flex-end;
}

.final-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.9em;
  min-width: 100px;
  white-space: nowrap;
}

/* Primary: Confirm Pinned (Blue BG) */
.btn-confirm-pinned {
  background-color: #9ABCE4;
  color: white;
  border: 1px solid #9ABCE4;
}
.btn-confirm-pinned:hover:not(:disabled) {
  background-color: #5E94D4;
}
.btn-confirm-pinned:disabled {
  background-color: #bbdefb;
  border-color: #bbdefb;
  cursor: not-allowed;
}
.btn-confirm-pinned-dark {
  background-color: #5E94D4;
  color: white;
  border: 1px solid #5E94D4;
}
.btn-confirm-pinned-dark:hover:not(:disabled) {
  background-color: #447EC7;
}
.btn-confirm-pinned-dark:disabled {
  background-color: #bbdefb;
  border-color: #bbdefb;
  cursor: not-allowed;
}

.btn-discard {
  color: #9ABCE4;
  border: 1px solid #9ABCE4;
  background-color: white;
}

.btn-discard:disabled {
  color: #DDE2E6;
  border-color: #DDE2E6;
}

.btn-discard:not(:disabled):hover {
  color: #5E94D4;
  border-color: #5E94D4;
}
.final-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.btn-icon {
  font-size: 18px;
}

/* Secondary: Confirm Timetable (Blue Border) */
.btn-confirm-timetable {
  background-color: white;
  color: #5e94d4;
  border: 1px solid #5e94d4;
}
.btn-confirm-timetable:hover {
  background-color: #e3f2fd;
}

.modal-layout-wrapper.without-preview {
  flex-direction: column;
  gap: 0;
}
.modal-layout-wrapper.without-preview .right-sidebar {
  width: 100% !important;
  padding-left: 0;
}
.text-hint-body {
  flex-shrink: 0;
  margin-top: 10px;
  font-size: 85%;
  line-height: 1.4em;
  color: #555;
}

.settings-active {
  color: #5e94d4 !important;
  font-variation-settings: 'FILL' 1 !important;
}

.settings-modified {
  color: #eab308 !important;
}

.settings-active.settings-modified {
  color: #eab308 !important;
  font-variation-settings: 'FILL' 1 !important;
}

</style>

<style>
.custom-wide-modal .modal-container,
.custom-wide-modal .modal-content { 
  width: 95vw !important; 
  max-width: 1550px !important; 
  height: 85vh !important;
  max-height: 85vh !important;
}
.custom-wide-modal .modal-body {
  overflow: hidden !important; 
  flex: 1;          
  display: flex;
  flex-direction: column;
  min-height: 0;   
}

.medium-wide-modal .modal-container,
.medium-wide-modal .modal-content { 
  width: 80vw !important; 
  max-width: 1100px !important; 
  height: 80vh !important;
  max-height: 80vh !important;
}
.medium-wide-modal .modal-body {
  overflow: hidden !important; 
  flex: 1;          
  display: flex;
  flex-direction: column;
  min-height: 0;   
}
.medium-wide-modal .modal-footer {
  align-items: center !important;
}
.medium-wide-modal .footer-buttons {
  width: auto !important;
  flex-shrink: 0;
  align-items: center !important;
}
</style>